import React, { useState } from "react";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import PublicIcon from "@mui/icons-material/Public";
import { Collapse } from "@mui/material";

import { useVeroFlag } from "shared/utils/featureFlags";
import { VeroFlag } from "shared/utils/veroFlags";

const BASE_SUPPORTED_COUNTRIES = [
  { name: "Australia", flag: "\u{1F1E6}\u{1F1FA}" },
  { name: "Canada", flag: "\u{1F1E8}\u{1F1E6}" },
  { name: "China", flag: "\u{1F1E8}\u{1F1F3}" },
  { name: "Guatemala", flag: "\u{1F1EC}\u{1F1F9}" },
  { name: "India", flag: "\u{1F1EE}\u{1F1F3}" },
  { name: "Mexico", flag: "\u{1F1F2}\u{1F1FD}" },
  { name: "Philippines", flag: "\u{1F1F5}\u{1F1ED}" },
  { name: "South Korea", flag: "\u{1F1F0}\u{1F1F7}" },
  { name: "Turkey", flag: "\u{1F1F9}\u{1F1F7}" },
  { name: "United Kingdom", flag: "\u{1F1EC}\u{1F1E7}" },
];

// PRODUCT-1949: only shown to companies with the use-intl-ocr-fixes flag enabled.
const INTL_OCR_FIXES_SUPPORTED_COUNTRIES = [
  { name: "Brazil", flag: "\u{1F1E7}\u{1F1F7}" },
  { name: "Colombia", flag: "\u{1F1E8}\u{1F1F4}" },
  { name: "Egypt", flag: "\u{1F1EA}\u{1F1EC}" },
  { name: "Israel", flag: "\u{1F1EE}\u{1F1F1}" },
  { name: "Jordan", flag: "\u{1F1EF}\u{1F1F4}" },
  { name: "Kuwait", flag: "\u{1F1F0}\u{1F1FC}" },
  { name: "Portugal", flag: "\u{1F1F5}\u{1F1F9}" },
  { name: "Saudi Arabia", flag: "\u{1F1F8}\u{1F1E6}" },
  { name: "Ukraine", flag: "\u{1F1FA}\u{1F1E6}" },
  { name: "United Arab Emirates", flag: "\u{1F1E6}\u{1F1EA}" },
];

const SupportedCountriesSection = () => {
  const [expanded, setExpanded] = useState(false);
  const isIntlOcrFixesEnabled = useVeroFlag(VeroFlag.useIntlOcrFixes);
  const SUPPORTED_COUNTRIES = isIntlOcrFixesEnabled
    ? [...BASE_SUPPORTED_COUNTRIES, ...INTL_OCR_FIXES_SUPPORTED_COUNTRIES].sort(
        (a, b) => a.name.localeCompare(b.name)
      )
    : BASE_SUPPORTED_COUNTRIES;

  return (
    <div style={{ paddingBottom: 16 }}>
      <button
        type="button"
        onClick={() => setExpanded(!expanded)}
        style={{
          display: "flex",
          alignItems: "center",
          gap: 6,
          background: "none",
          border: "none",
          cursor: "pointer",
          padding: "4px 0",
          color: "#666",
          fontSize: 13,
        }}
      >
        <PublicIcon style={{ fontSize: 16 }} />
        <span>Supported countries</span>
        <span
          style={{
            fontSize: 11,
            fontWeight: 600,
            color: "#6B6B8D",
            backgroundColor: "#F0F0F5",
            borderRadius: 10,
            padding: "1px 8px",
            lineHeight: "18px",
          }}
        >
          {SUPPORTED_COUNTRIES.length}
        </span>
        <ExpandMoreIcon
          style={{
            fontSize: 16,
            transform: expanded ? "rotate(180deg)" : "none",
            transition: "transform 0.2s",
          }}
        />
      </button>
      <Collapse in={expanded}>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: 6,
            padding: "8px 0 4px 0",
          }}
        >
          {SUPPORTED_COUNTRIES.map(({ name, flag }) => (
            <span
              key={name}
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 4,
                padding: "3px 8px",
                fontSize: 12,
                color: "#2D2943",
                backgroundColor: "#F7F7FA",
                borderRadius: 6,
                border: "1px solid #E8E8EE",
              }}
            >
              <span style={{ fontSize: 13 }}>{flag}</span>
              {name}
            </span>
          ))}
        </div>
      </Collapse>
    </div>
  );
};

export default SupportedCountriesSection;